import produce from 'immer'

import { GLOBAL, AUTH, USER_AGENT } from 'store/actions/types'

const initialState = {
    userAgentTransport: '',
    contactsListData: [],
    contactsFilteredListData: [],
    loadingContacts: false,
    contactsListPagination: {
        loading: true,
        page: 1,
        totalPages: 0,
        limit: 15
    },
    recentCallsData: [],
    recentCallsPagination: {
        loading: true,
        offset: 0,
        hasMore: true,
        period: 1,
        limit: 15
    },
    lastCall: {
        loading: false,
        number: null
    },
    didsData: [],
    didsDataLoaded: false,
    didsPagination: {
        loading: true,
        page: 1,
        totalPages: 0,
        limit: 15
    },
    isMicrophonePermissionDenied: false,
    isInternetConnectionLost: false,
    isMultipleTabs: undefined,
    tabId: '',
    isNotificationPermissionDenied: true,
    addNumberModalVisible: false,
    transferModalVisible: false,
    keypadModalVisible: false,
    error: '',
    alert: '',
    appStartAudioPlayed: false
}

export default function globalReducer(state = initialState, action) {
    const { type, payload } = action

    switch (type) {
        case GLOBAL.SET_INTERNET_CONNECTION_LOST:
            return produce(state, (draft) => {
                if (typeof payload === 'boolean') {
                    draft.isInternetConnectionLost = payload
                }
            })

        case GLOBAL.SET_MICRO_PHONE_PERMISSION_DENIED:
            return produce(state, (draft) => {
                if (typeof payload === 'boolean') {
                    draft.isMicrophonePermissionDenied = payload
                }
            })

        case GLOBAL.SET_MULTIPLE_TABS:
            return produce(state, (draft) => {
                if (typeof payload === 'boolean') {
                    draft.isMultipleTabs = payload
                }
            })

        case GLOBAL.SET_NOTIFICATION_PERMISSION_DENIED:
            return produce(state, (draft) => {
                draft.isNotificationPermissionDenied = payload
            })

        case GLOBAL.REQUEST_CONTACTS_START:
            return produce(state, (draft) => {
                draft.loadingContacts = true
            })

        case GLOBAL.REQUEST_CONTACTS_FINISH:
            return produce(state, (draft) => {
                draft.loadingContacts = false
            })

        case GLOBAL.GET_CONTACTS:
            return produce(state, (draft) => {
                if (payload) {
                    draft.contactsListPagination.loading = true
                }
            })

        case GLOBAL.GET_FILTERED_CONTACTS:
            return produce(state, (draft) => {
                if (payload) {
                    draft.contactsListPagination.loading = true
                }
            })

        case GLOBAL.GET_CONTACTS_FAIL:
            return produce(state, (draft) => {
                draft.contactsListPagination.loading = false
            })

        case GLOBAL.GET_CONTACTS_SUCCESS:
            return produce(state, (draft) => {
                draft.contactsListPagination.loading = false
                if (payload && payload.meta && payload.data) {
                    draft.contactsListData =
                        payload.meta.current_page === 1 ? payload.data : [...state.contactsListData, ...payload.data]
                    draft.contactsListPagination.page = payload.meta.current_page
                    draft.contactsListPagination.totalPages = payload.meta.last_page
                    draft.contactsListPagination.limit = payload.meta.per_page
                }
            })

        case GLOBAL.GET_CONTACTS_FILTERED_FAIL:
            return produce(state, (draft) => {
                draft.loadingContacts = false
            })

        case GLOBAL.GET_CONTACTS_FILTERED_SUCCESS:
            return produce(state, (draft) => {
                draft.contactsListPagination.loading = false
                draft.loadingContacts = false

                if (payload && payload.meta && payload.data) {
                    draft.contactsFilteredListData =
                        payload.meta.current_page === 1
                            ? payload.data
                            : [...state.contactsFilteredListData, ...payload.data]
                    draft.contactsListPagination.page = payload.meta.current_page
                    draft.contactsListPagination.totalPages = payload.meta.last_page
                    draft.contactsListPagination.limit = payload.meta.per_page
                } else {
                    draft.contactsFilteredListData = []
                }
            })

        case GLOBAL.GET_RECENTS:
            return produce(state, (draft) => {
                if (payload) {
                    draft.recentCallsPagination.loading = true
                }
            })

        case GLOBAL.GET_RECENTS_FAIL:
            return produce(state, (draft) => {
                draft.recentCallsPagination.loading = false
            })

        case GLOBAL.GET_RECENTS_SUCCESS:
            return produce(state, (draft) => {
                draft.recentCallsPagination.loading = false
                const { meta, data, offset, limit, reqPeriod, nextPeriod } = payload

                draft.recentCallsData = reqPeriod === 1 && offset === 0 ?  data : [...state.recentCallsData, ...data]
                draft.recentCallsPagination.hasMore = meta.hasMore
                draft.recentCallsPagination.offset = nextPeriod && Number.isInteger(nextPeriod.offset) ? nextPeriod.offset : offset + limit
                draft.recentCallsPagination.period = limit === 1 && offset === 0 ? 1 : nextPeriod?.period
            })

        case GLOBAL.RESET_RECENTS:
            return produce(state, (draft) => {
                draft.recentCallsData = initialState.recentCallsData
                draft.recentCallsPagination = initialState.recentCallsPagination
            })

        case GLOBAL.GET_LAST_CALL:
            return produce(state, (draft) => {
                draft.lastCall.loading = true
            })
        
        case GLOBAL.GET_LAST_CALL_FAIL:
            return produce(state, (draft) => {
                draft.lastCall.loading = false
            })

        case GLOBAL.GET_LAST_CALL_SUCCESS:
            return produce(state, (draft) => {
                const { number } = payload
                draft.lastCall.loading = false
                draft.lastCall.number = number
            })

        case GLOBAL.GET_DIDS:
            return produce(state, (draft) => {
                if (payload) {
                    draft.didsPagination.loading = true
                }
            })

        case GLOBAL.GET_DIDS_FAIL:
            return produce(state, (draft) => {
                draft.didsPagination.loading = false
            })

        case GLOBAL.GET_DIDS_SUCCESS:
            return produce(state, (draft) => {
                draft.didsPagination.loading = false
                draft.didsDataLoaded = true

                if (payload && payload.meta && payload.data) {
                    draft.didsData =
                        payload.meta.current_page === 1 ? payload.data : [...state.didsData, ...payload.data]
                    draft.didsPagination.page = payload.meta.current_page
                    draft.didsPagination.totalPages = payload.meta.last_page
                    draft.didsPagination.limit = payload.meta.per_page
                }
            })

        case GLOBAL.SET_CONTACTS_MODAL_VISIBLE:
            return produce(state, (draft) => {
                draft.addNumberModalVisible = payload
            })

        case GLOBAL.SET_TRANSFER_MODAL:
            return produce(state, (draft) => {
                draft.transferModalVisible = payload
            })

        case GLOBAL.SET_KEYPAD_MODAL_VISIBLE:
            return produce(state, (draft) => {
                draft.keypadModalVisible = payload
            })

        case GLOBAL.CLOSE_ALL_MODALS:
            return produce(state, (draft) => {
                draft.addNumberModalVisible = false
                draft.transferModalVisible = false
                draft.keypadModalVisible = false
            })

        case AUTH.SIGNOUT_USER_SUCCESS:
            return produce(state, (draft) => {
                draft.didsData = []
                draft.userAgentTransport = ''
                draft.appStartAudioPlayed = false
                draft.isMultipleTabs = false
            })

        case USER_AGENT.CHANGE_TRANSPORT:
            return produce(state, (draft) => {
                draft.userAgentTransport = payload.status
            })

        case GLOBAL.ERROR:
            return produce(state, (draft) => {
                draft.error = payload
            })

        case GLOBAL.ALERT:
            return produce(state, (draft) => {
                draft.alert = payload
            })

        case GLOBAL.SET_APP_START_AUDIO_PLAYED:
            return produce(state, (draft) => {
                draft.appStartAudioPlayed = true
            })

        case GLOBAL.SET_TAB_ID:
            return produce(state, (draft) => {
                draft.tabId = payload
            })
        default:
            return state
    }
}
